export const environment = {
  version: 0,
  APIBaseUrl: 'https://uat-services.pickright.co.in',
  token: 'marsRMToken',
  production: false,
  stage: true,
  develop: false,
  routePrefix: 'portfolio-advisory',
  stateId: 'userState'
};